import { useTranslation } from 'react-i18next';

/** GameScreen-level ErrorBoundary fallback — a game plugin crashed; the lobby shell itself is still fine. */
export function GameErrorFallback({ onReturnToLobby }: { onReturnToLobby: () => void }) {
  const { t } = useTranslation();
  return (
    <div className="error-fallback" role="alert" data-testid="game-error-fallback">
      <h1 className="error-fallback__title">{t('error.game.title')}</h1>
      <p className="error-fallback__message">{t('error.game.message')}</p>
      <button className="error-fallback__button" onClick={onReturnToLobby}>
        {t('error.game.returnToLobby')}
      </button>
    </div>
  );
}
